// extracted by mini-css-extract-plugin
module.exports = {"inlineFrame":"_4d28d1"};